<template>
    <div class="app-footer"
         v-show="shouldShow">
        <div class="row text-sm">
            <div class="col-4 d-none d-md-block">
                <div class="m-y">
                    <span>&copy; <strong>Aloware, Inc</strong> - With great power, comes great responsibility.</span>
                </div>
            </div>

            <div class="col-2 d-none d-md-block">
                <div class="text-sm-center text-xs-left m-y">
                    <span class="nav-link no-select">{{ env }} > {{ branch }}</span>
                </div>
            </div>

            <div :class="[env != 'production' ? 'col-4' : '']"
                 v-if="env == 'production'">
            </div>

            <div :class="[env != 'production' ? 'col-2' : 'col-6', 'd-none d-md-block']">
                <div class="m-y pull-right">
                    <span class="d-none d-sm-block-down">Built with <i class="fa fa-heart text-danger"></i>️ in City of Angels.</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                branch: null,
                env: null,
                whitelabel: false,
                loading_whitelabel: true,
            }
        },

        computed: {
            shouldShow() {
                return !this.whitelabel
            },
        },

        created() {
            this.getWhitelabelStatus()
        },

        methods: {
            getWhitelabelStatus() {
                this.loading_whitelabel = true
                axios.get('/get-statics')
                    .then(res => {
                        this.host = res.data.host
                        this.whitelabel = res.data.whitelabel
                        this.loading_whitelabel = false
                    })
                    .catch(err => {
                        console.log(err)
                        this.loading_whitelabel = false
                        this.$root.handleErrors(err.response)
                    })
            }
        },

        beforeCreate() {
            axios.get('/build-info.json')
                .then(res => {
                    this.branch = res.data.branch
                    this.env = res.data.env
                })
                .catch(err => {
                    console.log(err)
                })
        },
    }
</script>
